module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "message-board-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "message-board-root"
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "comment-container"
  }, [_c('div', {
    attrs: {
      "id": "SOHUCS",
      "sid": "homepage"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3557c326"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message-board/message-board.vue
// module id = 183
// module chunks = 0